import { Link } from "react-router-dom";
import { Button } from "../../../components/Button";
import { Badge } from "../../../components/Circle";
import { MarkText } from "../../../components/MarkText";
import { Paragraph } from "../../../components/Text";
import { CircleIcon } from "../../../icons/CircleIcon";
import { DownloadIcon } from "../../../icons/DownloadIcon";
import { EditIcon } from "../../../icons/EditIcon";
import { RemoveIcon } from "../../../icons/RemoveIcon";
import { YESNO } from "../../../settings";
import { fixPackageSize, formatDate, highlightText } from "../../../utils";

export const licenses = ({ isAdmin, licenseRead, showForm, org, orgName, downloadLicense, pathname, search, context, editValues, deleteItem }) => ({
    enabled: licenseRead,
    header: isAdmin &&
        <Button onClick={() => showForm("licenses")}>
            Add License
        </Button>,
    columns: [
        {
            title: <CircleIcon size={16} />,
            dataIndex: 'expired',
            width: 50,
            render: (text, record, index) => (
                    <Badge color={ text < 0 ? "var(--sp-error-color)" : text > 10 ? "var(--sp-success-color)" : "var(--sp-warning-color)" } />
                ),
            sorter: (a, b) => { if (a && a.hasOwnProperty("expired")) return a.expired - b.expired}
        },
        {
            title: "Name",
            dataIndex: "fileName",
            defaultSortOrder: "asc",
            render: (text, record, index) => (
                <Link to={{ pathname: `${pathname}/${record.id}`, state: { from: pathname + search } }}>
                    <MarkText title={text} text={highlightText(text, context)} />
                </Link>
            ),
            sorter: (a, b) => { if (a && a.hasOwnProperty("fileName") && a.fileName) return a.fileName.localeCompare(b.fileName)}
        },
        {
            title: "Expiration Date",
            dataIndex: "expiryDate",
            width: 150,
            render: (text, record, index) => formatDate(text, "DD-MMM-YYYY"),
            sorter: (a, b) => { if (a && a.hasOwnProperty("expiryDate") && a.expiryDate) return a.expiryDate.localeCompare(b.expiryDate)}
        },
        org
        ? {}
        : {
            title: "Organization",
            dataIndex: "orgName",
            ellipsis: true,
            render: (text, record, index) => (
                <Link to={`/organisations/${record.orgAlias}`}>
                    <MarkText nowrap title={text} text={highlightText(text, context)} />
                </Link>
            ),
            sorter: (a, b) => { if (a && a.hasOwnProperty("orgName") && a.orgName) return a.orgName.localeCompare(b.orgName) }
        },
        isAdmin
        ? {
            title: "Uploaded By",
            dataIndex: "uploadedBy",
            render: (text, record, index) => (
                <MarkText nowrap title={text} text={highlightText(text, context)} />
            ),
            sorter: (a, b) => { if (a && a.hasOwnProperty("uploadedBy") && a.uploadedBy) return a.uploadedBy.localeCompare(b.uploadedBy)}
        }
        : {
            title: "File size",
            dataIndex: "fileSize",
            width: 150,
            render: (text, record, index) => fixPackageSize(text),
            sorter: (a, b) => { if (a && a.hasOwnProperty("fileSize")) return a.fileSize - b.fileSize}
        },
        {
            dataIndex: "download",
            width: 50,
            render: (text, record, index) => (
                <DownloadIcon
                    size={20}
                    color="var(--sp-label-color)"
                    hoverColor="var(--sp-paragraph-color)"
                    onClick={() => downloadLicense(record.id)}
                />
            )
        },
        isAdmin
        ? {
            dataIndex: "edit",
            width: 50,
            render: (text, record, index) => (
                <EditIcon
                    size={20}
                    color="var(--sp-label-color)"
                    hoverColor="var(--sp-paragraph-color)"
                    onClick={() => editValues({ entity: "licenses", values: record })}
                />
            )
        } : {},
        isAdmin
        ? {
            dataIndex: "remove",
            width: 50,
            render: (text, record, index) => (
                <RemoveIcon
                    size={20}
                    color="var(--sp-label-color)"
                    hoverColor="var(--sp-error-color)"
                    onClick={() => deleteItem({ content: <Paragraph>Are you sure you want to delete the <Paragraph bold>{record.fileName}</Paragraph> license for <b>{record.orgName}</b>?</Paragraph>, values: record.id })}
                />
            )
        }
        : {}
    ],
    searchOptions:
    isAdmin
    ? [
        { key: "expired", title: "Expired", type: "boolean", options: YESNO, placeholder: "The expiration status of licenses." }
    ]
    : [],
    breadcrumbs: org
    ? [
        { title: orgName, href: "/organisations/" + org },
        { title: "Licenses" }
    ]
    : null
})